import {Swiper, Navigation, Pagination} from 'swiper/dist/js/swiper.esm.js'
import {forEach} from "../../js/helpers";
import {break_sm} from "../../js/constants";

Swiper.use([Pagination, Navigation]);

setTimeout(function () {
  forEach(document.querySelectorAll(".itemsBlock"), item => {
    new Swiper(item.querySelector('.itemsBlock__slider'), {
        speed: 500,
        slidesPerView: 'auto',
        navigation: {
          nextEl: item.querySelector('.swiper-button-next'),
          prevEl: item.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: item.querySelector('.swiper-pagination'),
          type: 'fraction'
        },
        watchOverflow: true,
        on: {
          init: function () {
            this.$el[0].classList.add('is-item-footer-hidden');
            this.$el[0].style.height = this.$el[0].offsetHeight + 'px'
          },
        },
      }
    );
  });
}, 500);

if (window.innerWidth <= break_sm) {
  forEach(document.querySelectorAll(".itemsBlock"), item => {
    new Swiper(item.querySelector('.itemsBlock__middle'), {
        speed: 500,
        slidesPerView: 'auto',
        freeMode: true
      }
    );
  });
}
